// Controla os campos das informações
(function () {
  'use strict';

  // Variáveis
  const $campoTipoDesconto = $('input[name="tipo"]');
  const $campoValorWrp = $('.valor_desconto_wrp');
  const $campoValor = $('#valor_desconto');
  const $campoPorcentagemWrp = $('.porcentagem_desconto_wrp');
  const $campoPorcentagem = $('#porcentagem_desconto');
  const $campoLimitarUsos = $('#limitar_usos');
  const $campoLimiteUsosWrp = $('.limite_usos_wrp');
  const $campoLimiteUsos = $('#limite_usos');
  const $campoLimitarDatas = $('#limitar_datas');
  const $campoLimiteDatasWrp = $('.limite_datas_wrp');
  const $campoDataInicio = $('#data_inicio');
  const $campoDataFim = $('#data_fim');

  $campoTipoDesconto.on('change', handleTipoDesconto);
  $campoLimitarUsos.on('change', handleLimiteUsos);
  $campoLimitarDatas.on('change', handleLimiteDatas);

  // Ao alterar o tipo de desconto
  handleTipoDesconto();
  function handleTipoDesconto() {
    if ($('input[name="tipo"]:checked').val() == 'valor') {
      $campoPorcentagemWrp.hide();
      $campoPorcentagem.prop('required', false);
      $campoValorWrp.show();
      $campoValor.prop('required', true);
    } else {
      $campoPorcentagemWrp.show();
      $campoPorcentagem.prop('required', true);
      $campoValorWrp.hide();
      $campoValor.prop('required', false);
    }
  }

  // Ao alterar se haverá limite de usos
  handleLimiteUsos();
  function handleLimiteUsos() {
    if ($campoLimitarUsos.is(':checked')) {
      $campoLimiteUsosWrp.show();
      $campoLimiteUsos.prop('disabled', false);
      $campoLimiteUsos.prop('required', true);
    } else {
      $campoLimiteUsosWrp.hide();
      $campoLimiteUsos.prop('disabled', true);
      $campoLimiteUsos.prop('required', false);
    }
  }

  // Ao alterar se haverá limite de datas
  handleLimiteDatas();
  function handleLimiteDatas() {
    if ($campoLimitarDatas.is(':checked')) {
      $campoLimiteDatasWrp.show();
      $campoDataInicio.prop('disabled', false);
      $campoDataInicio.prop('required', true);
      $campoDataFim.prop('disabled', false);
      $campoDataFim.prop('required', true);
    } else {
      $campoLimiteDatasWrp.hide();
      $campoDataInicio.prop('disabled', true);
      $campoDataInicio.prop('required', false);
      $campoDataFim.prop('disabled', true);
      $campoDataFim.prop('required', false);
    }
  }
})();
